// import { useState, useEffect } from "react";
// import SizeGuide from "../modal/SizeGuide";
//
// const SizePicker = ({ selectedGuid, onSelect, variants = [] }) => {
//     const [activeGuid, setActiveGuid] = useState(selectedGuid || null);
//
//     // useEffect(() => {
//     //     setActiveGuid(selectedGuid);
//     // }, [selectedGuid]);
//
//     useEffect(() => {
//         console.log("[SizePicker] props changed:", {
//             selectedGuid,
//             variantsCount: variants.length,
//             variants: variants.map(v => ({
//                 size: v.size,
//                 guid: v.guid,
//                 quantity: v.quantity,
//                 isStock: v.isStock,
//             })),
//         });
//         setActiveGuid(selectedGuid || null);
//     }, [selectedGuid, variants]);
//
//     // activeGuid değişince logla
//     useEffect(() => {
//         const selected = variants.find(v => v.guid === activeGuid) || null;
//         console.log("[SizePicker] activeGuid ->", activeGuid, "selected:", selected);
//     }, [activeGuid, variants]);
//
//     const handleSizeClick = (variant) => {
//         setActiveGuid(variant.guid);
//         onSelect?.(variant.guid);
//     };
//
//     return (
//         <div className="variant-picker-item variant-size">
//             <div className="variant-picker-label">
//                 <div>
//                     Size:
//                     <span className="variant-picker-label-value value-currentSize">
//                         {
//                             variants.find(v => v.guid === activeGuid)?.size || "Select"
//                         }
//                     </span>
//                 </div>
//                 <a href="#sizeGuide" data-bs-toggle="modal" className="size-guide link">
//                     Size Guide
//                 </a>
//             </div>
//             <div className="variant-picker-values">
//                 {variants.map((variant) => (
//                     <span
//                         key={variant.guid}
//                         className={`size-btn ${variant.guid === activeGuid ? "active" : ""}`}
//                         data-size={variant.size}
//                         onClick={() => handleSizeClick(variant)}
//                     >
//                         {variant.size}
//                     </span>
//                 ))}
//             </div>
//         </div>
//     );
// };
//
// export default SizePicker;

import { useState, useEffect } from "react";
import SizeGuide from "../modal/SizeGuide";

const SizePicker = ({ selectedGuid, onSelect, variants = [] }) => {
    const [activeGuid, setActiveGuid] = useState(selectedGuid || null);

    // İlk yüklemede/props değişince: mümkünse stokta olan ilk varyantı otomatik seç
    useEffect(() => {
        if (selectedGuid) {
            setActiveGuid(selectedGuid);
            return;
        }
        const firstInStock = variants.find(v => Number(v.quantity) > 0 && v.isStock !== false);
        setActiveGuid(firstInStock ? firstInStock.guid : null);
    }, [selectedGuid, variants]);

    const handleSizeClick = (variant) => {
        const disabled = Number(variant.quantity) <= 0 || variant.isStock === false;
        if (disabled) return; // seçime izin verme
        setActiveGuid(variant.guid);
        onSelect?.(variant.guid);
    };

    return (
        <div className="variant-picker-item variant-size">
            <div className="variant-picker-label">
                <div>
                    Size:{" "}
                    <span className="variant-picker-label-value value-currentSize">
            {variants.find(v => v.guid === activeGuid)?.size || "Select"}
          </span>
                </div>
                <a href="#sizeGuide" data-bs-toggle="modal" className="size-guide link">
                    Size Guide
                </a>
            </div>

            <div className="variant-picker-values">
                {variants.map((variant) => {
                    const disabled = Number(variant.quantity) <= 0 || variant.isStock === false;
                    const isActive = variant.guid === activeGuid;

                    return (
                        <span
                            key={variant.guid}
                            className={`size-btn ${isActive ? "active" : ""} ${disabled ? "disabled" : ""}`}
                            data-size={variant.size}
                            aria-disabled={disabled}
                            tabIndex={disabled ? -1 : 0}
                            title={disabled ? "Out of stock" : ""}
                            onClick={() => handleSizeClick(variant)}
                        >
              {variant.size}
            </span>
                    );
                })}
            </div>
        </div>
    );
};

export default SizePicker;
